// extracted by mini-css-extract-plugin
export default {"bannedContainer":"BannedUser_bannedContainer__lSnEz"};